import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { BsPerson, BsCodeSlash } from "react-icons/bs";
import { CgFileDocument } from "react-icons/cg";
import { LuBriefcase } from "react-icons/lu";
import "./style.css";

const Nav = () => {
  const [navbarBlur, setNavbarBlur] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY >= 20) {
        setNavbarBlur(true);
      } else {
        setNavbarBlur(false);
      }
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  // Đóng menu mobile
  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
      <nav className={`Navbar ${navbarBlur ? "blur" : ""}`}>
        <Link to="/" className="logoLink" onClick={closeMenu}>
          <img
            src="/images/trung_logo.png"
            alt="Nguyen Dang Trung Logo"
            className="logo_image"
          />
        </Link>

        {/* Mobile Hamburger Button */}
        <div
          className={`Hamburger ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
          role="button"
          tabIndex={0}
        >
          <span className={`bar ${isMenuOpen ? "barOne" : ""}`}></span>
          <span className={`bar ${isMenuOpen ? "barTwo" : ""}`}></span>
          <span className={`bar ${isMenuOpen ? "barThree" : ""}`}></span>
        </div>

        {/* Navigation Links */}
        <ul className={`NavbarLinks ${isMenuOpen ? "showNavbar" : ""}`}>
          <li onClick={closeMenu}>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
            >
              <AiOutlineHome className="navIcon" />
              <span>Home</span>
            </NavLink>
          </li>
          <li onClick={closeMenu}>
            <NavLink
              to="/About"
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
            >
              <BsPerson className="navIcon" />
              <span>About</span>
            </NavLink>
          </li>
          <li onClick={closeMenu}>
            <NavLink
              to="/Experience"
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
            >
              <LuBriefcase className="navIcon" />
              <span>Experience</span>
            </NavLink>
          </li>
          <li onClick={closeMenu}>
            <NavLink
              to="/Project"
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
            >
              <BsCodeSlash className="navIcon" />
              <span>Project</span>
            </NavLink>
          </li>
          <li onClick={closeMenu}>
            <NavLink
              to="/Resume"
              className={({ isActive }) => (isActive ? "navLink active" : "navLink")}
            >
              <CgFileDocument className="navIcon" />
              <span>Resume</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* Backdrop overlay for mobile menu */}
      {isMenuOpen && (
        <div
          className="mobileNavBackdrop"
          onClick={closeMenu}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Nav;
